import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import Text, { H1 } from 'components/common/Text/Text'

const ValueProposition = ({ placeholders: { teasers = []} = {}, title, ...props }) =>
  <OuterWrapper>
    { /* OuterWrapper - Temporary wrapper for full size bg */ }
    <Wrapper data-at-value-proposition-wrapper>
      <Media.Desktop>
        <Title headline noMargin data-at-title>Looking for tires and auto service? Start here!</Title>
      </Media.Desktop>
      <Media.Mobile>
        <Title headline noMargin data-at-title>The Big O Tires Experience</Title>
        <Description size={ 20 } data-at-description>{ title }</Description>
      </Media.Mobile>
      <TeaserWrapper>{ teasers }</TeaserWrapper>
    </Wrapper>
  </OuterWrapper>

ValueProposition.propTypes = {
  '@type': PropTypes.string,
  name: PropTypes.string,
  placeholders: PropTypes.shape({
    teasers: PropTypes.arrayOf(PropTypes.shape())
  }),
  title: PropTypes.string
}

ValueProposition.type = 'ValueProposition'
ValueProposition.placeholders = ['teasers']

export default ValueProposition

const OuterWrapper = styled.div`
  background: #fcfcfc;
`

const Wrapper = styled.div`
  text-align: center;
  ${Mixin.responsive('padding', '55px 50px 25px 60px', '52px 8px 14px')}
  ${Mixin.clearFix()}
`
const Title = styled(H1)`
  ${Mixin.font.GothamBold(24, 900)}
  ${Mixin.responsive('padding-bottom', '5px', '15px')}
  ${Media.desktop`
    text-transform: none;
    margin-bottom: -35px;
  `}
  ${Media.mobile`
    font-size: 22px;
  `}
`

const Description = styled(Text)`
  ${Mixin.desktopOnly()}
`

const TeaserWrapper = styled.div`
  width: 100%;
  ${Media.desktop`
    display: table;
    margin-top: 50px;
  `}
`
